import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';

function FieldVideoPlayer({ lang, t }) {
  const it = lang === 'it';
  const [started, setStarted] = useState(false);
  const [failed, setFailed] = useState(false);
  const src = `/videos/plantadopting-homepage-${it ? 'it' : 'en'}.mp4`;
  const label = t('homePolish.watchVideo');

  return (
    <div className="w-full max-w-[240px] mx-auto">
      <div className="relative aspect-[9/16] overflow-hidden rounded-lg bg-[#293D2C]">
        {started ? (
          <video
            className="h-full w-full object-contain"
            src={src}
            poster="/videos/plantadopting-homepage-poster.jpg"
            controls
            autoPlay
            playsInline
            preload="none"
            aria-label={label}
            onError={() => { setStarted(false); setFailed(true); }}
          >
            {t('homePolish.videoUnsupported')}
          </video>
        ) : (
          <button
            type="button"
            className="group absolute inset-0 w-full h-full focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-[-4px] focus-visible:outline-[#E3B24C]"
            aria-label={label}
            onClick={() => { setFailed(false); setStarted(true); }}
          >
            <img src="/videos/plantadopting-homepage-poster.jpg" alt="" loading="lazy" width="720" height="1280" className="h-full w-full object-contain" />
            <span className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-black/15 group-hover:bg-black/25">
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#FFFDF8] text-[#557448] shadow-lg"><Play size={28} aria-hidden="true" /></span>
              <span className="rounded-md bg-[#293D2C]/90 px-3 py-2 text-sm text-white">{label}</span>
            </span>
          </button>
        )}
      </div>
      {failed && <p role="alert" className="mt-2 text-sm">{t('homePolish.videoUnavailable')} <a href={src} className="underline">{t('homePolish.openVideoFile')}</a>.</p>}
      <p className="pa-home-description text-xs text-[#5C4636]/80 mt-2">{t('homePolish.videoLanguage')}</p>
    </div>
  );
}

export default function HomeFieldVideo() {
  const { lang, t } = useLang();
  return <FieldVideoPlayer key={lang} lang={lang} t={t} />;
}

